/** Organization datagrid key base — full key is `${LOCATIONS_DATAGRID_KEY}_${organizationId}` */
export const LOCATIONS_DATAGRID_KEY = "Locations_grid";

export const LOCATION_DEFAULT_COLUMNS = [
  {
    field: "location_name",
    label: "Location Name",
    visible: true,
    width: 200,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "addressline1",
    label: "Address Line 1",
    visible: true,
    width: 220,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "city_name",
    label: "City",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "state_name",
    label: "State",
    visible: true,
    width: 140,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "country_name",
    label: "Country",
    visible: true,
    width: 140,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "postal_code",
    label: "Postal Code",
    visible: true,
    width: 130,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "location_ownership_type_name",
    label: "Ownership Type",
    visible: false,
    width: 160,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "number_of_floors",
    label: "Floors",
    visible: false,
    width: 100,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "area_sq_ft",
    label: "Area (sq ft)",
    visible: false,
    width: 120,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const LOCATION_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: [
    "location_name",
    "addressline1",
    "city_name",
    "state_name",
    "country_name",
    "postal_code",
  ],
  columnLabels: Object.fromEntries(
    LOCATION_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    LOCATION_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const LOCATION_PERSONALIZE_COLUMN_KEYS = LOCATION_DEFAULT_COLUMNS.map(
  (col) => col.field
).concat(["addressline2", "location_latitude", "location_longitude"]);

const COLUMN_FIELD_ALIASES = {
  City: "city_name",
  city: "city_name",
  State: "state_name",
  state: "state_name",
  Country: "country_name",
  country: "country_name",
  LocationOwnershiptype: "location_ownership_type_name",
  location_ownership_type: "location_ownership_type_name",
  name: "location_name",
};

export function normalizeLocationColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  if (COLUMN_FIELD_ALIASES[raw]) return COLUMN_FIELD_ALIASES[raw];
  const lower = raw.toLowerCase();
  return COLUMN_FIELD_ALIASES[lower] || raw;
}

export function mapSavedLocationColumns(savedColumns = []) {
  const labelByField = LOCATION_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeLocationColumnField(col.field || col.key);
      if (!field || field === "organization_location_id") return null;

      const defaultCol = LOCATION_DEFAULT_COLUMNS.find((c) => c.field === field);

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}

export function resolveLocationApiField(field) {
  return normalizeLocationColumnField(field);
}
